module.exports = __webpack_public_path__ + "img/ECU_for_Nissan_Leaf3.32e542bf.jpg";